<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="mapOptions" ref="line" auto-resize style='width: 100%;height:100%' v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/map'
import 'echarts/map/js/world'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      ready: false,
      dataState: 'loading',
      timeInterval: 'day',
      hourly: false,
      months: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ],
      mapOptions: {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            let sentiment = 'No data'
            if (params.hasOwnProperty('value')) {
              if (Math.round(params.value) === -2) {
                sentiment = 'Very Negative'
              } else if (Math.round(params.value) === -1) {
                sentiment = 'Negative'
              } else if (Math.round(params.value) === 0) {
                sentiment = 'Neutral'
              } else if (Math.round(params.value) === 1) {
                sentiment = 'Positive'
              } else if (Math.round(params.value) === 2) {
                sentiment = 'Very Positive'
              }
            }
            return '<div style="text-align:center;font-weight:bold">' + params.name + '</div><div style="text-align:justify"><b>Average: ' + sentiment + ' Value: ' + parseFloat(params.value).toFixed(2) + '</b><br/>Very Positive: ' + (sentiment !== 'No data' ? params.data.data.vpositive : 0) + '<br/>Positive: ' + (sentiment !== 'No data' ? params.data.data.positive : 0) + '<br/>Neutral: ' + (sentiment !== 'No data' ? params.data.data.neutral : 0) + '<br/>Negative: ' + (sentiment !== 'No data' ? params.data.data.negative : 0) + '<br/>Very Negative: ' + (sentiment !== 'No data' ? params.data.data.vnegative : 0) + '<br/></div>'
          }
        },
        visualMap: {
          min: -2,
          max: 2,
          text: ['Very Positive', 'Very Negative'],
          realtime: false,
          calculable: true,
          inRange: {
            color: ['#e80036', '#ff5930', '#ffae42', '#00bfa9', '#00e8af']
          }
        },
        series: {
          data: [],
          name: 'World Sentiment',
          type: 'map',
          mapType: 'world',
          mapValueCalculation: 'max',
          roam: true,
          itemStyle: {
            emphasis: {
              areaColor: '#ffffff',
              label: {
                show: true,
                color: '#000000'
              }
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery']),
    ...mapGetters({getCountryMap: 'getCountryMap'})
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTwitterSentimentCountry', this.getQuery({}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let sentimap = {}
          for (let i = 0; i < r1.data.payload.length; i++) {
            if (r1.data.payload[i]._sentiment !== 100) {
              if (r1.data.payload[i]._country_name in sentimap) {
                if (r1.data.payload[i]._sentiment === -2) {
                  sentimap[r1.data.payload[i]._country_name]['vnegative'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === -1) {
                  sentimap[r1.data.payload[i]._country_name]['negative'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === 0) {
                  sentimap[r1.data.payload[i]._country_name]['neutral'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === 1) {
                  sentimap[r1.data.payload[i]._country_name]['positive'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === 2) {
                  sentimap[r1.data.payload[i]._country_name]['vpositive'] = r1.data.payload[i]._tweet_count
                }
                sentimap[r1.data.payload[i]._country_name].sentiment = sentimap[r1.data.payload[i]._country_name].sentiment + r1.data.payload[i]._sentiment * r1.data.payload[i]._tweet_count
                sentimap[r1.data.payload[i]._country_name].total = sentimap[r1.data.payload[i]._country_name].total + r1.data.payload[i]._tweet_count
              } else {
                sentimap[r1.data.payload[i]._country_name] = {sentiment: r1.data.payload[i]._sentiment * r1.data.payload[i]._tweet_count, total: r1.data.payload[i]._tweet_count}
                if (r1.data.payload[i]._sentiment === -2) {
                  sentimap[r1.data.payload[i]._country_name]['vnegative'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === -1) {
                  sentimap[r1.data.payload[i]._country_name]['negative'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === 0) {
                  sentimap[r1.data.payload[i]._country_name]['neutral'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === 1) {
                  sentimap[r1.data.payload[i]._country_name]['positive'] = r1.data.payload[i]._tweet_count
                } else if (r1.data.payload[i]._sentiment === 2) {
                  sentimap[r1.data.payload[i]._country_name]['vpositive'] = r1.data.payload[i]._tweet_count
                }
              }
            }
          }
          for (var key in sentimap) {
            this.mapOptions.series.data.push({
              name: this.getCountryMap[key],
              value: 1.0 * sentimap[key].sentiment / sentimap[key].total,
              data: {
                vnegative: sentimap[key].hasOwnProperty('vnegative') ? sentimap[key].vnegative : 0,
                negative: sentimap[key].hasOwnProperty('negative') ? sentimap[key].negative : 0,
                neutral: sentimap[key].hasOwnProperty('neutral') ? sentimap[key].neutral : 0,
                positive: sentimap[key].hasOwnProperty('positive') ? sentimap[key].positive : 0,
                vpositive: sentimap[key].hasOwnProperty('vpositive') ? sentimap[key].vpositive : 0
              }
            })
          }
          this.dataState = 'ready'
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let line = this.$refs.line
          if (line) {
            line.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let line = this.$refs.line
          if (line) {
            line.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ArticlesAndTweetsMapSentiment.vue